import { useAppSelector } from '@/store';
import { selectManageAccessStep } from '@/store/selectors/manageAccess';

export function useManageAccessStepper() {
  const step = useAppSelector(selectManageAccessStep);

  return {
    state: {
      step,
    },
  };
}
